import { Controller } from "@hotwired/stimulus"
import { safeStorageGet, safeStorageSet } from "../utils/safe_storage"

const storageKey = (sectionKey) => `admin-sidebar-section-${sectionKey}`

// Collapsible nav groups (Content, Accounts, …); persists open/closed in localStorage.
export default class extends Controller {
  connect() {
    this.element.querySelectorAll(".admin-dashboard__sidebar-section").forEach((section) => {
      this.applyStored(section)
    })
  }

  toggle(event) {
    const section = event.currentTarget.closest(".admin-dashboard__sidebar-section")
    if (!section) return

    const panel = section.querySelector(".admin-dashboard__sidebar-section-panel")
    const button = event.currentTarget
    if (!panel || !button) return

    const expanded = button.getAttribute("aria-expanded") === "true"
    const nextOpen = !expanded
    this.setSectionOpen(section, button, nextOpen)
    const key = section.getAttribute("data-section-key")
    if (key) safeStorageSet(localStorage, storageKey(key), nextOpen ? "open" : "closed")
  }

  applyStored(section) {
    const key = section.getAttribute("data-section-key")
    if (!key) return

    const panel = section.querySelector(".admin-dashboard__sidebar-section-panel")
    const button = section.querySelector(".admin-dashboard__sidebar-section-toggle")
    if (!panel || !button) return

    if (safeStorageGet(localStorage, storageKey(key)) === "closed") {
      this.setSectionOpen(section, button, false)
    }
  }

  setSectionOpen(section, button, open) {
    button.setAttribute("aria-expanded", String(open))
    if (open) {
      section.classList.remove("is-section-collapsed")
    } else {
      section.classList.add("is-section-collapsed")
    }
  }
}
